import { LuRefreshCw } from 'react-icons/lu'
import { cn } from '@cannect/lib/utils'
import { recurrencyCopy } from '../copy'

export * from './useRecurrencyBadges'

type RecurrencyBadgeProps = { state: 'available' | 'unavailable'; className?: string }

export const RecurrencyBadge = ({ state, className }: RecurrencyBadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
      state === 'available' ? 'bg-primary-100 text-primary-800' : 'bg-gray-100 text-gray-600',
      className
    )}>
    <LuRefreshCw aria-hidden="true" className="h-3 w-3" />
    {recurrencyCopy.badge[state]}
  </span>
)
